import {AfterViewInit, Component, ElementRef, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {Option} from '../../../shared/models/option';
import {ClickService} from '../../../core/services/click.service';
import {ConnectedPosition} from '@angular/cdk/overlay';
import {Subscription} from 'rxjs';
import {Tile} from "../../../shared/models/tile";
import {TileComponent} from '../tile/tile.component';

@Component({
  selector: 'motn-popover-tile',
  templateUrl: './popover-tile.component.html',
  styleUrls: ['./popover-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    forwardRef(() => TileComponent),
  ],
})
export class PopoverTileComponent implements OnDestroy, AfterViewInit {
  @Input() rawTile: Tile;
  @Output() clickedOption$: EventEmitter<Option> = new EventEmitter<Option>();
  @Output() clickedOutside$: EventEmitter<null> = new EventEmitter<null>();
  @Output() clickedAnywhere$: EventEmitter<Option | null> = new EventEmitter<Option | null>();

  clickSub: Subscription;
  overlayPositions: ConnectedPosition[] = [{
    originX: 'start',
    originY: 'center',
    overlayX: 'start',
    overlayY: 'center',
  }];

  constructor(
    private eRef: ElementRef,
    private clickService: ClickService,
  ) {
  }

  ngAfterViewInit() {
    this.clickSub = this.clickService.click$.subscribe(
      ($el) => {
        if (!this.eRef.nativeElement.contains($el)) {
          this.clickedOutside$.emit(null);
          this.clickedAnywhere$.emit(null);
        }
      },
    );
  }


  ngOnDestroy() {
    this.clickSub?.unsubscribe();
  }
}
